<template>
    <div class="kqsx d-flex">
        <div class="kqsx-result w-100">
            <h1 class="kqsx-result__title">DÒ KẾT QUẢ XỔ SỐ</h1>
            <div class="kqsx-result__filter d-flex w-100">
                <div
                    class="kqsx-result__filter-date d-flex w-50 align-items-center justify-content-start justify-content-lg-start"
                >
                <div class="history__box-filter-date--wrap">
                    <label for="fromDate">Ngày</label>
                    <InputDatepicker
                        :config="datepickerConfig"
                        v-model="selectedDate"
                        name="datepicker"
                        @onChange="onChangeDate"
                        id="fromDate"
                    />
                    </div>
                </div>
                <div
                    class="kqsx-result__filter-channel d-flex w-50 align-items-center justify-content-end justify-content-lg-start"
                >
                <div class="history__box-filter-date--wrap">
                    <label for="display">Đài</label>
                    <label class="kqsx-result__select-channel">
                        <Select
                            @change="changeChanel"
                            v-model="selectedChanel"
                            :options="channels"
                            id="display"
                    /></label>
                </div>
                </div>
                <div
                    class="kqsx-result__button-box d-none d-lg-flex align-items-center"
                >
                    <Button
                        value="Xem"
                        @click="clickViewResult"
                        theme="dark"
                        variant="secondary"
                        class="w-100 btn-custom"
                    />
                </div>
            </div>

            <div
                class="kqsx-result__button-box d-flex align-items-center d-lg-none w-100"
            >
                <Button
                    value="Xem"
                    @click="clickViewResult"
                    theme="dark"
                    variant="secondary"
                    class="w-100 btn-custom"
                />
            </div>
            <div
                v-if="channelLogoJson[this.selectedChanelDisplay.value]"
                class="kqsx-result__channel-logo d-flex align-items-center"
            >
                <div class="kqsx-result__channel-logo-box mr-2">
                    <picture
                        class="kqsx-result__channel-logo-icon d-inline-block"
                    >
                        <source
                            :srcset="
                                require('@/assets/images/channel-logo/' +
                                    getCityLogo() +
                                    '.webp')
                            "
                            type="image/webp"
                        />
                        <img
                            :src="
                                require('@/assets/images/channel-logo/' +
                                    getCityLogo() +
                                    '.png')
                            "
                            :alt="getCityLogo()"
                        />
                    </picture>
                </div>

                <div class="game__channel-name">
                    Đài
                    {{ this.selectedChanelDisplay.name }}
                    <span v-if="isMobile">Ngày {{ selectedDateDisplay }}</span>
                </div>
            </div>
            <p class="kqsx-result__sub-title d-none d-lg-block">
                KẾT QUẢ XỔ SỐ NGÀY {{ selectedDateDisplay }}
            </p>

            <div v-if="isMobile" class="kqsx-result__tabs-container">
                <ul class="w-100 p-0">
                    <li
                        @click="changeTab"
                        :class="{ 'tabs-container-active': isKqsxTab }"
                    >
                        Dò Kết Quả
                    </li>
                    <li
                        @click="changeTab"
                        :class="{ 'tabs-container-active': !isKqsxTab }"
                    >
                        Thống Kê
                    </li>
                </ul>
            </div>
            <div v-if="isKqsxTab">
                <transition name="fade" mode="out-in">
                    <Spinner v-if="loadingResult" />
                    <div v-else>
                        <KqxsTable
                            v-if="awardResults && awardResults.id"
                            :awardResults="awardResults"
                        />
                        <p v-else class="red-color">
                            CHƯA CÓ KẾT QUẢ
                        </p>
                    </div>
                </transition>
            </div>
            <div class="w-100" v-if="!isKqsxTab">
                <StatisticalTable
                    :appearData="appearData"
                    :city="selectedChanelDisplay.value"
                    :selectedDate="selectedDate"
                    @search-number-time="searchNumberTimes"
                    :loading="loadingStatistics"
                    :notAppearData="notAppearData"
                    :numberTurn="numberTurn"
                />
            </div>
        </div>
        <div class="statistical d-none d-lg-flex mt-180">
            <StatisticalTable
                :appearData="appearData"
                :notAppearData="notAppearData"
                :city="selectedChanelDisplay.value"
                :selectedDate="selectedDate"
                @search-number-time="searchNumberTimes"
                :loading="loadingStatistics"
                :numberTurn="numberTurn"
            />
        </div>
    </div>
</template>

<script>
import KqxsTable from '@/components/common/KqxsTable/KqxsTable';
import Select from '@/components/common/Select/Select';
import resultService from '@common/services/result.service';
import kqsxResultService from '@common/services/kqsxResult.service';
import { mapActions, mapGetters } from 'vuex';
import InputDatepicker from '@/components/common/InputDatepicker/InputDatepicker';
import channelLogoJson from '@/assets/common/json/channel-logo.json';
import Button from '@/components/common/Button/Button';
import StatisticalTable from '@/components/common/StatisticalTable/StatisticalTable';
import Spinner from '@/components/common/Spinner/Spinner';
import userService from '@common/services/user.service';
const moment = require('moment');

export default {
    components: {
        Select,
        Button,
        InputDatepicker,
        KqxsTable,
        StatisticalTable,
        Spinner,
    },
    data() {
        return {
            awardResults: {},
            datepickerConfig: {
                dateFormat: 'd-m-Y',
                disableMobile: 'true',
            },

            channels: [],
            selectedChanel: {},
            selectedDate: null,
            selectedDateDisplay: null,
            selectedChanelDisplay: {},
            channelLogoJson: channelLogoJson,
            isMobile: false,
            isKqsxTab: true,
            appearData: [],
            loadingResult: false,
            loadingStatistics: false,
            notAppearData: [],
            numberTurn: '10',
        };
    },

    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, {
                passive: true,
            });
        }
    },
    mounted() {
        this.onResize();
        window.addEventListener('resize', this.onResize, { passive: true });
    },

    methods: {
        ...mapActions({
            fetchStartDate: 'userModule/fetchStartDate',
        }),

        onResize() {
            this.isMobile = window.innerWidth < 992;
            if (!this.isMobile) {
                this.isKqsxTab = true;
            }
        },

        changeChanel: async function(channel) {
            this.selectedChanel = { ...channel };
        },

        onChangeDate: async function({ dateStr }) {
            this.selectedDate = dateStr;
            this.channels = [];
            this.loadingResult = true;
            await this.loadDataChannel();
            this.loadingResult = false;
        },

        async clickViewResult() {
            try {
                this.loadingResult = true;
                this.selectedChanelDisplay = { ...this.selectedChanel };
                this.selectedDateDisplay = this.selectedDate;
                const result = await this.getKqsxResultData(
                    this.selectedDate,
                    this.selectedChanel.value,
                );
                this.setDataKqsxResult(result.data);
                this.loadingResult = false;
                this.searchNumberTimes(10).then();
            } catch (e) {
                console.log(e);
            }
        },

        getCityLogo() {
            const cityId = this.selectedChanelDisplay.value;
            return this.channelLogoJson[cityId]
                ? this.channelLogoJson[cityId].logo
                : 'not_found';
        },

        changeTab() {
            this.isKqsxTab = !this.isKqsxTab;
            if (!this.isMobile) {
                this.searchNumberTimes(10);
            }
        },

        getKqsxResultData(date, city) {
            return kqsxResultService.getKqsxResultData(date, city);
        },

        setDataKqsxResult(data) {
            if (data.rows && data.rows.result && data.rows.result.id) {
                this.awardResults = data.rows.result;
            } else {
                this.awardResults = {};
            }
        },

        setDatepickerOptions(date) {
            const currentDate = moment(date, 'DD-MM-YYYY');
            const afterTomorrow = new Date(currentDate).setDate(
                new Date(currentDate).getDate() + 1,
            );
            return {
                dateFormat: 'd-m-Y',
                disableMobile: 'true',
                enable: [
                    {
                        from: '01-01-1970',
                        to: moment(afterTomorrow).format('DD-MM-YYYY'),
                    },
                ],
            };
        },

        async loadDataChannel() {
            const [
                resultNorth,
                resultCentral,
                resultSouth,
            ] = await Promise.all([
                resultService.getResultData('bac', this.selectedDate, {}),
                resultService.getResultData('trung', this.selectedDate, {}),
                resultService.getResultData('nam', this.selectedDate, {}),
            ]);
            this.channels.push(
                ...resultNorth.data.rows.map(v => ({
                    name: v.name,
                    value: v.id,
                })),
            );
            this.channels.push(
                ...resultCentral.data.rows.map(v => ({
                    name: v.name,
                    value: v.id,
                })),
            );
            this.channels.push(
                ...resultSouth.data.rows.map(v => ({
                    name: v.name,
                    value: v.id,
                })),
            );
            this.selectedChanel = this.channels[0];
            await this.clickViewResult();
        },
        async searchNumberTimes(times) {
            this.loadingStatistics = true;
            let minusDate = 7;
            if (this.selectedChanel.value === 1) {
                minusDate = 1;
            }
            await this.getKqsxResultDataByDates(
                this.getDateRange(this.selectedDate, times, minusDate),
            );
            this.numberTurn = times.toString();
            this.loadingStatistics = false;
        },

        getDateRange(date, times, minusDate) {
            const dates = [];
            dates.push(date);
            let dateTemp = date;
            for (let i = 1; i < times; i++) {
                dateTemp = moment(dateTemp, 'DD-MM-YYYY')
                    .subtract(minusDate, 'd')
                    .format('DD-MM-YYYY');
                dates.push(dateTemp);
            }
            return dates;
        },

        async getKqsxResultDataByDates(dates) {
            const promises = [];
            dates.map(v => {
                const pms = new Promise((resolve, reject) => {
                    this.getKqsxResultData(v, this.selectedChanel.value)
                        .then(res => {
                            resolve(res);
                        })
                        .catch(e => {
                            reject(e);
                        });
                });
                promises.push(pms);
            });
            const values = await Promise.all(promises);
            this.setKqsxResultDataByDates(values);
        },

        setKqsxResultDataByDates(arrData) {
            let strTwooflast = '';
            let strTwooflast2 = '';
            arrData.forEach(v => {
                if (
                    v &&
                    v.data.rows &&
                    v.data.rows.result &&
                    v.data.rows.result.id
                ) {
                    strTwooflast += ' ' + v.data.rows.result.twooflast;
                    strTwooflast2 +=
                        ' ' +
                        this.removeDuplicateString(
                            v.data.rows.result.twooflast,
                        );
                }
            });
            this.notAppearData = this.getArrOccurrencesNumber(strTwooflast2);
            this.appearData = this.getArrOccurrencesNumber(strTwooflast);
        },

        removeDuplicateString(str) {
            let strTemp = str;
            if (str.length >= 135) {
                strTemp = str.substring(0, str.length - 3);
            }
            const arrData = strTemp.split(' - ');
            const uniq = [...new Set(arrData)];
            return uniq.join(' ');
        },

        getArrOccurrencesNumber(text) {
            let status = [];
            if (typeof text === 'string') {
                status = text
                    .split(' ')
                    .filter(word => word.length >= 2)
                    .reduce((reduced, word) => {
                        reduced[word] = reduced[word] ? reduced[word] + 1 : 1;
                        return reduced;
                    }, {});
            }
            return this.sortNumberOccurrences(status);
        },

        sortNumberOccurrences(stats) {
            let statsArray = Object.keys(stats).map(key => {
                return { value: key, number: stats[key] };
            });
            return statsArray.sort((a, b) => {
                return b.number - a.number;
            });
        },
    },

    async created() {
        await this.fetchStartDate();
        const res = await userService.getLastDate();
        this.selectedDate = res.data.rows.date;
        this.selectedDateDisplay = this.selectedDate;
        this.datepickerConfig = this.setDatepickerOptions(this.selectedDate);
        if (!this.isMobile) {
            await this.searchNumberTimes(10);
        }
    },

    computed: {
        ...mapGetters({
            currentDate: 'userModule/startDate',
        }),
    },
};
</script>

<style scoped lang="scss">
@import 'Result.scss';
</style>
